<template>
    <nut-swiper ref="swiperRef" :init-page="0" :is-prevent-default="false" @change="swiperChangeHandle" :loop="true"
        :auto-play="3000" class="news-swiper">
        <nut-swiper-item class="news-item-box" v-for="(item) in swiperList" :key="item.icon">
            <!-- <nut-image :src="getImageUrl(item)" lazy-load /> -->
             <img :src="getImageUrl(item)" alt="" loading="lazy">
            <!-- <Image :src="getImageUrl(item)" :size="{ width: 639, height: 337 }" /> -->
        </nut-swiper-item>
        <template #page>
            <div class="swiper-pagination" v-if="swiperList.length > 1">
                <!-- {{ currentPage }}/ {{ swiperList.length }} -->
                <div class="page-dot" :class="{
                    active: index + 1 === currentPage
                }" v-for="(item, index) in swiperList.length" :key="item"></div>
            </div>
        </template>
    </nut-swiper>
</template>

<script lang="ts" setup>
import { nextTick, ref, watch } from 'vue';
import config from '@img/config.json';

const baseCdn = 'https://g20.gsf.netease.com/h5_swiper_202510211812/'
const swiperRef = ref()

defineProps({
    swiperList: {
        type: Array,
        default: () => ([])
    }
})
const currentPage = ref(1)

function swiperChangeHandle(val: number) {
    currentPage.value = val + 1
}
function getImageUrl(item) {
    // console.log(item);
    if (!!item) {
        return `${baseCdn}${item.icon}` + '.jpg';
    }
}
</script>


<style lang="scss" scoped>
.news-swiper {
    position: relative;
    width: 639px;
    height: 337px;
    font-size: 24px;
    // padding-bottom: 50px;

    .news-item-box {
        width: 639px;
        height: 337px;

        img {
            width: 100%;
            height: 100%;
        }
    }

    .swiper-pagination {
        position: absolute;
        left: 10px;
        bottom: 0;
        // transform: translate(-50%, 0);
        display: flex;
        align-items: center;

        .page-dot {
            @include bg('dian_3');
            margin-right: 10px;

            &:last-child {
                margin-right: 0;
            }

            &.active {
                @include bg('dian_4');
            }
        }
    }
}
</style>